<header>
  <div class="brand">
    <img
      src="assets/boatmu-gallery-white.png"
      alt="Logo"
      class="logo link"
      (click)="redirect('/app')"
    />
  </div>

  <div class="ms-auto">
    <ng-container *ngIf="isLoggedIn; else loggedOut">
      <div class="btn-group me-3" ngbTooltip="Home">
        <button type="button" class="btn btn-icon btn-home" (click)="redirect('/app')">
          <i class="material-icons mi-26">home</i>
        </button>
      </div>

      <div class="btn-group paid-photos-container" *hasRight="roleType.USER">
        <button class="btn btn-paid-photos me-3" (click)="redirect('/app/#/user/photos/paid')">
          Paid Photos
        </button>
      </div>

      <div class="btn-group me-3" ngbTooltip="My Cart" *hasRight="roleType.USER">
        <button type="button" class="btn btn-icon btn-cart" (click)="onCartClick()">
          <i class="material-icons mi-26">shopping_cart</i>
          <span
            *ngIf="hasCartItems"
            class="position-absolute start-50 badge rounded-pill bg-dark"
            >{{ cartTotal }}</span
          >
        </button>
      </div>

      <div class="btn-group" ngbDropdown placement="bottom-right">
        <button ngbDropdownToggle class="btn btn-sm btn-transparent btn-icon">
          <div class="userpic-stub" [ngStyle]="{ 'background-image': getUserImageUrl() }"></div>
        </button>

        <div ngbDropdownMenu class="text-end">
          <div ngbDropdownItem [disabled]="true" class="current-user-email">
            {{ currentUserEmail }}
          </div>
          <div class="dropdown-divider"></div>
          <button class="paid-photos-mobile" ngbDropdownItem routerLink="/user/photos/paid">
            Paid Photos
          </button>
          <div class="dropdown-divider paid-photos-mobile"></div>
          <button ngbDropdownItem (click)="onLogout()">Logout</button>
        </div>
      </div>
    </ng-container>

    <ng-template #loggedOut>
      <!-- Show webview warning if detected -->
      <div
        *ngIf="isWebview; else normalSignIn"
        class="webview-signin-warning d-flex align-items-center"
      >
        <!-- Cart icon for guest users in webview -->
        <div class="btn-group" ngbTooltip="My Cart">
          <button type="button" class="btn btn-icon btn-cart" (click)="onCartClick()">
            <i class="material-icons mi-26">shopping_cart</i>
            <span
              *ngIf="hasCartItems"
              class="position-absolute start-50 badge rounded-pill bg-dark"
              >{{ cartTotal }}</span
            >
          </button>
        </div>

        <div class="btn-group" ngbTooltip="Home">
          <button type="button" class="btn btn-icon btn-home" (click)="redirect('/app')">
            <i class="material-icons mi-26">home</i>
          </button>
        </div>
        <button class="signin-link webview-blocked" type="button" (click)="onWebviewSignInClick()">
          <img class="logo" src="assets/icons/google.svg" alt="Google Login" />
          <span class="signin-text">Sign In<br /><small>(Open in Browser)</small></span>
        </button>
      </div>

      <ng-template #normalSignIn>
        <div class="normal-signin d-flex align-items-center">
          <!-- Cart icon for guest users -->
          <div class="btn-group" ngbTooltip="My Cart">
            <button type="button" class="btn btn-icon btn-cart" (click)="onCartClick()">
              <i class="material-icons mi-26">shopping_cart</i>
              <span
                *ngIf="hasCartItems"
                class="position-absolute start-50 badge rounded-pill bg-dark"
                >{{ cartTotal }}</span
              >
            </button>
          </div>

          <div class="btn-group" ngbTooltip="Home">
            <button type="button" class="btn btn-icon btn-home" (click)="redirect('/app')">
              <i class="material-icons mi-26">home</i>
            </button>
          </div>
          <a class="signin-link" [href]="googleOAuthURL">
            <img class="logo" src="assets/icons/google.svg" alt="Google Login" />
            Sign In
          </a>
        </div>
      </ng-template>
    </ng-template>
  </div>
</header>
